// import React from 'react'
// import './ProductDisplay.css'
// import star_icon from '../Assets/Frontend_Assets/star_icon.png'
// import star_dull_icon from '../Assets/Frontend_Assets/star_dull_icon.png'
// const ProductDisplay = (props) => {
//     const { product } = props;
//     return (
//         <div className='productdisplay'>
//             <div className='productdisplay-left'>
//                 <div className='productdisplay-img-list'>
//                     <img src={product.image} alt="" />
//                     <img src={product.image} alt="" />
//                     <img src={product.image} alt="" />
//                     <img src={product.image} alt="" />
//                 </div>
//                 <div className='productdisplay-img'>
//                     <img className='productdisplay-main-img' src={product.image} alt="" />
//                 </div>
//             </div>
//             <div className='productdisplay-right'>
//                 <h1>{product.name}</h1>
//                 <div className='productdisplay-right-stars'>
//                     <img src={star_icon} alt="" />
//                     <img src={star_icon} alt="" />
//                     <img src={star_icon} alt="" />
//                     <img src={star_icon} alt="" />
//                     <img src={star_dull_icon} alt="" />
//                     <p>(122)</p>
//                 </div>
//                 <div className='productdisplay-right-prices'>
//                     <div className='productdisplay-right-price-old'>
//                         ${product.old_price}
//                     </div>
//                     <div className='productdisplay-right-price-new'>
//                         ${product.new_price}
//                     </div>
//                 </div>
//                 <div className='productdisplay-right-description'>
//                     {/* A lightweight, usually knitted, pullover shirt, close-fitting and with a round neckline and short sleeves, worn as an undershirt or outer garment. */}
//                     {product.description}
//                 </div>
//                 <div className='productdisplay-right-size'>
//                     <h1>Select Size</h1>
//                     <div className='productdisplay-right-sizes'>
//                         <div>S</div>
//                         <div>M</div>
//                         <div>L</div>
//                         <div>Xl</div>
//                         <div>XXl</div>
//                     </div>
//                 </div>
//                 <button>ADD TO CART</button>
//                 <p className='productdisplay-right-category'><span>Category: </span> Women, T-shirt , CropTop </p>
//                 <p className='productdisplay-right-category'><span>Category: </span> {product.category}</p>
//                 <p className='productdisplay-right-category'><span>Tags: </span>Modern, Latest </p>
//             </div>
//         </div>
//     )
// }

// export default ProductDisplay

// import React, { useState } from 'react';
// import './ProductDisplay.css';
// import star_icon from '../Assets/Frontend_Assets/star_icon.png';
// import star_dull_icon from '../Assets/Frontend_Assets/star_dull_icon.png';

// const ProductDisplay = ({ product }) => {
//     const [selectedImage, setSelectedImage] = useState(product.image);

//     return (
//         <div className="productdisplay">
//             <div className="productdisplay-left">
//                 <div className="productdisplay-img-list">
//                     {[1, 2, 3, 4].map((_, i) => (
//                         <img
//                             key={i}
//                             src={product.image}
//                             alt={`Thumbnail ${i + 1}`}
//                             onClick={() => setSelectedImage(product.image)}
//                             className={selectedImage === product.image ? 'active' : ''}
//                         />
//                     ))}
//                 </div>
//                 <div className="productdisplay-img">
//                     <img
//                         className="productdisplay-main-img"
//                         src={selectedImage}
//                         alt={product.name}
//                     />
//                 </div>
//             </div>

//             <div className="productdisplay-right">
//                 <h1>{product.name}</h1>

//                 <div className="productdisplay-right-stars">
//                     {[...Array(4)].map((_, i) => (
//                         <img key={i} src={star_icon} alt="star" />
//                     ))}
//                     <img src={star_dull_icon} alt="dull star" />
//                     <p>(122)</p>
//                 </div>

//                 <div className="productdisplay-right-prices">
//                     <div className="productdisplay-right-price-old">
//                         ${product.old_price}
//                     </div>
//                     <div className="productdisplay-right-price-new">
//                         ${product.new_price}
//                     </div>
//                 </div>

//                 <div className="productdisplay-right-description">
//                     {product.description || "A lightweight, comfortable and stylish garment perfect for any occasion."}
//                 </div>

//                 <div className="productdisplay-right-size">
//                     <h2>Select Size</h2>
//                     <div className="productdisplay-right-sizes">
//                         {['S', 'M', 'L', 'XL', 'XXL'].map((size) => (
//                             <div key={size} className="size-option">
//                                 {size}
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <button className="add-to-cart-btn">ADD TO CART</button>

//                 <div className="productdisplay-right-categories">
//                     <p><span>Category:</span> Women, T-Shirt, Crop Top</p>
//                     <p><span>Subcategory:</span> {product.category}</p>
//                     <p><span>Tags:</span> Modern, Latest, Trendy</p>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ProductDisplay;


import React, { useState, useEffect, useContext } from 'react';
import './ProductDisplay.css';
import star_icon from '../Assets/Frontend_Assets/star_icon.png';
import star_dull_icon from '../Assets/Frontend_Assets/star_dull_icon.png';
import { ShopContext } from '../../Context/ShopContext';

const ProductDisplay = ({ product }) => {
    const [selectedImage, setSelectedImage] = useState(product.image);
    const [selectedSize, setSelectedSize] = useState('');
    const { addToCart } = useContext(ShopContext);

    useEffect(() => {
        setSelectedImage(product.image);
        setSelectedSize('');
    }, [product]);

    const handleAddToCart = () => {
        addToCart(product.id, selectedSize);
    };

    return (
        <div className="productdisplay">
            <div className="productdisplay-left">
                <div className="productdisplay-img-list">
                    {[1, 2, 3, 4].map((_, i) => (
                        <img
                            key={i}
                            src={product.image}
                            alt={`Thumbnail ${i + 1}`}
                            onClick={() => setSelectedImage(product.image)}
                            className={selectedImage === product.image ? 'active' : ''}
                        />
                    ))}
                </div>

                <div className="productdisplay-img">
                    <img
                        className="productdisplay-main-img"
                        src={selectedImage}
                        alt={product.name}
                    />
                </div>
            </div>

            <div className="productdisplay-right">
                <h1>{product.name}</h1>

                <div className="productdisplay-right-stars">
                    {[...Array(4)].map((_, i) => (
                        <img key={i} src={star_icon} alt="star" />
                    ))}
                    <img src={star_dull_icon} alt="dull star" />
                    <p>(122)</p>
                </div>

                <div className="productdisplay-right-prices">
                    <div className="productdisplay-right-price-old">
                        ${product.old_price}
                    </div>
                    <div className="productdisplay-right-price-new">
                        ${product.new_price}
                    </div>
                </div>

                <div className="productdisplay-right-description">
                    {product.description ||
                        'A lightweight, comfortable and stylish garment perfect for any occasion.'}
                </div>

                <div className="productdisplay-right-size">
                    <h2>Select Size</h2>
                    <div className="productdisplay-right-sizes">
                        {['S', 'M', 'L', 'XL', 'XXL'].map((size) => (
                            <div
                                key={size}
                                className={`size-option ${selectedSize === size ? 'selected' : ''}`}
                                onClick={() => setSelectedSize(size)}
                            >
                                {size}
                            </div>
                        ))}
                    </div>
                </div>

                <button
                    onClick={handleAddToCart}
                    className="add-to-cart-btn"
                    disabled={!selectedSize}
                >
                    ADD TO CART
                </button>

                <div className="productdisplay-right-categories">
                    {/* <p><span>Category:</span> Women, T-Shirt, Crop Top</p> */}
                    <p><span>Subcategory:</span> {product.category}</p>
                    <p><span>Tags:</span> Modern, Latest, Trendy</p>
                </div>
            </div>
        </div>
    );
};

export default ProductDisplay;
